export class PenBracketTypeDto {
  public static ApiUrl = 'api/pen-bracket-type';

  Id: number;
  Type: number;
  Name: string;
  NameEn: string;
  NameEs: string;
}
